export enum ActionType {
    CollectPoints,
    UsePoints
}